// var mobileCheck11 = function() {
//     let check = false;
//     (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
//     return check;
// };
// if(!mobileCheck11()){
//    var container = document.querySelector(".desktop-hide-test"); // Select the div with the class 'container'
//   if(container){
//     var element = container.querySelector("#ss-product-video-4"); 
//   if (element) {
//       element.removeAttribute("id"); // Remove the id attribute
//     }
//   }
// }
// window.addEventListener('blur', () => {
//   document.querySelectorAll('.mega-menu-container').forEach(menu => {
//     menu.style.display = 'none';
//   });
// });
function openCity(evt, cityName) {
  // Declare all variables
  var i, tabcontent, tablinks;

  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}
  
// Select all elements with the class "MonitorArmRails"
  const hoverDivs = document.querySelectorAll('.video-test');

  // Loop through each element and add event listeners
  hoverDivs.forEach(div => {
    const video = div.querySelector('video'); // Get the video element

    if (video) {
      // Play video on hover
      div.addEventListener('mouseover', () => {
        video.play();
      });

      // Reset and pause video on mouseout
      div.addEventListener('mouseout', () => {
        video.currentTime = 0; // Reset video to the beginning
        video.pause(); // Pause the video
      });
    }
  });
          
// $(document).ready(function(){
// 	var maxLength = 300;
// 	$(".show-read-more").each(function(){
// 		var myStr = $(this).text();
// 		if($.trim(myStr).length > maxLength){
// 			var newStr = myStr.substring(0, maxLength);
// 			var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
// 			$(this).empty().html(newStr);
// 			$(this).append('<br><a href="javascript:void(0);" class="read-more">Read more...</a>');
// 			$(this).append('<span class="more-text">' + removedStr + '</span>');
// 		}
// 	});
//       $(document).on("click",".read-more",function() {

//             	$(".show-read-more").append(' <br><a href="javascript:void(0);" class="read-less">Read less...</a>');
// 	var abc =	$(this).siblings(".more-text").contents().unwrap();
// 		$(this).remove();
     
// 	});
 
//     $(document).on("click",".read-less",function() {
// 	var maxLength = 300;
// 	$(".show-read-more").each(function(){
// 		var myStr = $(this).text();
// 		if($.trim(myStr).length > maxLength){
// 			var newStr = myStr.substring(0, maxLength);
// 			var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
// 			$(this).empty().html(newStr);
// 			$(this).append(' <br><a href="javascript:void(0);" class="read-more">Read more...</a>');
// 			$(this).append('<span class="more-text">' + removedStr + '</span>');
// 		}
// 	});
     
// 	});

// });

// jQuery(document).ready(function($)
//                        {
//   //   $('.fulltext').hide();

//   $('.readmore').insertAfter( '.show-read-more' );

//   $('.readmore').click(function (event) {
//     event.preventDefault();
//     var description = document.querySelector('.show-read-more');
//     console.log(description.style.height)
//     if (description.style.height === ''){
//       description.style.height = 'auto';
//     } else if (description.style.height === 'auto'){
//       description.style.height = '';
//     }
//     else{
//       description.style.height = '92px';
//     }

//     $(this).text($(this).text() == 'Read less...' ? 'Read more...' : 'Read less...');
//   });
//    var display_content = $('.variant-input input:checked').val().split(" ").join("");
//   $('.'+display_content).show();
//   $('.variant-input').click(function (event) {
//       var display_content1 = $(this).attr("data-value");
//     display_content1=display_content1.split(" ").join("");
//     $('.hide-content-custom').hide();
//     $('.'+display_content1).show();
//   });
// });

// jQuery('.special-box-bottom').slick({
//   autoplay: true,
// "dots": false,
// "arrows": true,
// "infinite": false,
// "adaptiveHeight": true,
// "slidesToShow": 5,
// "slidesToScroll": 4,
//         responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 4,
//             slidesToScroll: 4,
//             adaptiveHeight: true,
//           },
//         },
//         {
//           breakpoint: 600,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1,
//           },
//         },
//       ]
    
// });

//           jQuery('#dimension-box-link-wheel').click(function(){
//   $("#dimension-box-wheel").show();
//   var modlwindow = document.getElementById("dimension-box-wheel");
//   window.onclick = function(event) {
//     if (event.target == modlwindow) {
//       modlwindow.style.display = "none";
//     }
//   }
// });
// jQuery('#dimension-box-close-wheel').click(function(){
//   $("#dimension-box-wheel").hide();
// });  
// jQuery('#dimension-box-link-front').click(function(){
//   $("#dimension-box-front").show();
//   var modlwindow = document.getElementById("dimension-box-front");
//   window.onclick = function(event) {
//     if (event.target == modlwindow) {
//       modlwindow.style.display = "none";
//     }
//   }
// });                               
// jQuery('#dimension-box-close-front').click(function(){
//   $("#dimension-box-front").hide();
// }); 
// jQuery('#dimension-box-link-sim').click(function(){
//   $("#dimension-box-sim").show();
//   var modlwindow = document.getElementById("dimension-box-sim");
//   window.onclick = function(event) {
//     if (event.target == modlwindow) {
//       modlwindow.style.display = "none";
//     }
//   }
// });
// jQuery('#dimension-box-close-sim').click(function(){
//   $("#dimension-box-sim").hide();
// }); 
// jQuery('#dimension-box-link-fanatec').click(function(){
//   $("#dimension-box-fanatec").show();
//   var modlwindow = document.getElementById("dimension-box-fanatec");
//   window.onclick = function(event) {
//     if (event.target == modlwindow) {
//       modlwindow.style.display = "none";
//     }
//   }
// });
// jQuery('#dimension-box-close-fanatec').click(function(){
//   $("#dimension-box-fanatec").hide();
// }); 


// jQuery('.prime-landing-trust-badge').slick({
//     "prevArrow": '<img src="https://cdn.shopify.com/s/files/1/0105/3664/8767/files/ios-arrow-back.svg?v=1669130647" class="left-arrow-badge">',
//  "nextArrow": '<img src="https://cdn.shopify.com/s/files/1/0105/3664/8767/files/ios-arrow-forward.svg?v=1669130648" class="right-arrow-badge">',
//   autoplay: true,
// "dots": false,
// "arrows": true,
// "infinite": true,
// "adaptiveHeight": true,
// "slidesToShow": 6,
// "slidesToScroll": 6,
//         responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 3,
//             slidesToScroll: 3,
//             adaptiveHeight: true,
//           },
//         },
//         {
//           breakpoint: 600,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1,
//           },
//         },
//       ]
    
// });
// jQuery('.reviews-row-prime-cockpit-slider').slick({
//    "prevArrow": '<img src="https://cdn.shopify.com/s/files/1/0105/3664/8767/files/ios-arrow-back_91c60204-c00a-49cd-aec2-7d72e60d058a.svg?v=1669197712" class="left-arrow-black">',
//  "nextArrow": '<img src="https://cdn.shopify.com/s/files/1/0105/3664/8767/files/ios-arrow-forward_be10d9c7-c6b9-483c-9dd2-ef112fdc008a.svg?v=1669197711" class="right-arrow-black">',
//   autoplay: true,
// "dots": false,
// "arrows": true,
// "infinite": true,
// "adaptiveHeight": true,
// "slidesToShow": 4,
// "slidesToScroll": 4,
//         responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1,
//             adaptiveHeight: true,
//           },
//         },
//         {
//           breakpoint: 600,
//           settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1,
//           },
//         },
//       ]
    
// });
// jQuery('.prime-cockpit-seat').slick({
//   "prevArrow": '<img src="https://cdn.shopify.com/s/files/1/0051/5886/2936/files/ios-arrow-back.png?v=1671476999" class="left-arrow arrow-seat-new-left">',
//  "nextArrow": '<img src="https://cdn.shopify.com/s/files/1/0051/5886/2936/files/ios-arrow-forward.png?v=1671476999" class="right-arrow arrow-seat-new-right">',
//   autoplay: true,
// "dots": false,
// "arrows": true,
// "infinite": true,
// "adaptiveHeight": true,
// "slidesToShow": 3,
// "slidesToScroll": 3,
//         responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1,
//             adaptiveHeight: true,
//           },
//         },
//         {
//           breakpoint: 600,
//           settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1,
//           },
//         },
//       ]
    
// });
// $("#show-dis").click(function(){
//   $("#pop-up-klaviyo").show();
// });
// $("#show-dis-desktop").click(function(){
//   $("#pop-up-klaviyo").show();
// });
// $("#pop-up-klaviyo-close").click(function(){
//   $("#pop-up-klaviyo").hide();
// });
// jQuery('.prime-moza-product').slick({
//    "prevArrow": '<img src="https://cdn.shopify.com/s/files/1/0105/3664/8767/files/ios-arrow-back_91c60204-c00a-49cd-aec2-7d72e60d058a.svg?v=1669197712" class="left-arrow-black">',
//  "nextArrow": '<img src="https://cdn.shopify.com/s/files/1/0105/3664/8767/files/ios-arrow-forward_be10d9c7-c6b9-483c-9dd2-ef112fdc008a.svg?v=1669197711" class="right-arrow-black">',
//   autoplay: true,
// "dots": false,
// "arrows": true,
// "infinite": true,
// "adaptiveHeight": true,
// "slidesToShow": 3,
// "slidesToScroll": 3,
//         responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1,
//             adaptiveHeight: true,
//           },
//         },
//         {
//           breakpoint: 600,
//           settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1,
//           },
//         },
//       ]
    
// });

// jQuery('.prime-moza-reviews').slick({
//    "prevArrow": '<img src="https://cdn.shopify.com/s/files/1/0105/3664/8767/files/ios-arrow-back.svg?v=1669130647" class="left-arrow">',
//  "nextArrow": '<img src="https://cdn.shopify.com/s/files/1/0105/3664/8767/files/ios-arrow-forward.svg?v=1669130648" class="right-arrow">',
//   autoplay: true,
// "dots": false,
// "arrows": true,
// "infinite": true,
// "adaptiveHeight": true,
// "slidesToShow": 3,
// "slidesToScroll": 3,
//         responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1,
//             adaptiveHeight: true,
//           },
//         },
//         {
//           breakpoint: 600,
//           settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1,
//           },
//         },
//       ]
    
// });
// jQuery('.middle-pro-five-slider').slick({
//     dots: false,
//     autoplay: true,
//     pauseOnHover: false,
//     autoplaySpeed: 2500,
//     slidesToShow: 5,
//     slidesToScroll: 1,  
//     infinite: true,
//     cssEase: 'linear',
//     prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0051/5886/2936/files/arrow-left.png?v=1671729479" class="left-arrow">',
//     nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0051/5886/2936/files/arrow-right.png?v=1671729479" class="right-arrow">',
//     arrows: true,  
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           infinite: true,
//           arrows: true,
//           dots: false
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           infinite: true,
//           arrows: true,          
//           dots: false
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows: true,          
//           infinite: true,
//           dots: false
//         }
//       }     
//     ]
//   });


// jQuery('.icon-slide-panel').slick({
//   autoplay: true,
// "dots": false,
// "arrows": false,
// "adaptiveHeight": true,
// "slidesToShow": 9,
// "slidesToScroll": 9,
//         responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 4,
//             slidesToScroll: 4,
//             adaptiveHeight: true,
//           },
//         },
//         {
//           breakpoint: 767,
//           settings: {
//             slidesToShow: 3,
//             slidesToScroll: 3
//           },
//         },
//       ]
    
// });
// $('.two-slide').slick({
//     dots: false,
//     infinite: false,
//     speed: 300,
//      prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0051/5886/2936/files/arrow-left_14236f6d-8983-46f6-8d4f-28c511c1a18d.png?v=1674216771" class="left-arrow-middle">',
//     nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0051/5886/2936/files/arrow-right_b1afc4ac-e66e-4afd-8f24-8f838ae4a97a.png?v=1674216771" class="right-arrow-middle">',  
//     slidesToShow: 3,
//     slidesToScroll: 3,    
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2,
//           infinite: true,
//           dots: false
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           centerMode: false,
//           infinite: true,
//           dots: false
//         }
//       },
//       {
//         breakpoint: 736,
//         settings: {
//           slidesToShow: 2,
//           centerMode: false,
//           slidesToScroll: 1,
//           infinite: true,
//           dots: false
//         }
//       }     
//     ]
//   });

// jQuery('.home-product-slider').slick({
//   "prevArrow": '<img src="https://cdn.shopify.com/s/files/1/0105/3664/8767/files/ios-arrow-back_91c60204-c00a-49cd-aec2-7d72e60d058a.svg?v=1669197712" class="left-arrow">',
//  "nextArrow": '<img src="https://cdn.shopify.com/s/files/1/0105/3664/8767/files/ios-arrow-forward_be10d9c7-c6b9-483c-9dd2-ef112fdc008a.svg?v=1669197711" class="right-arrow">',
//   autoplay: false,
// "dots": false,
// "arrows": true,
// "infinite": true,
//   "centerMode": false,
// "adaptiveHeight": true,
// "slidesToShow": 4,
// "slidesToScroll": 4,
//         responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1,
//             adaptiveHeight: true,
//           },
//         },
//         {
//           breakpoint: 600,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1,
//           },
//         },
//       ]
    
// });
// jQuery(".search-custom-link").click(function(){
//     jQuery(".boost-pfs-search-box").click(); 
//     // return false;
// });

// jQuery('#ProductSelect-2010734035032-option-material-Leather').click(function(){
//    $(".ProductSelectImg-2010734035032-option-color-Black").attr("src","https://cdn.shopify.com/s/files/1/0260/5259/1691/products/BLACK_1G_2992001b-aaf5-42ca-b367-d53aa1384ae1_178x.jpg?v=1645637100");
//   jQuery('#ProductSelect-2010734035032-option-color-Black').click();
// })
//     jQuery('#ProductSelect-2010734035032-option-material-Fabric').click(function(){
//        $(".ProductSelectImg-2010734035032-option-color-Black").attr("src","https://cdn.shopify.com/s/files/1/0260/5259/1691/products/PRO_Black_Fabric_1B_1f4a8152-3c17-4656-add1-1f23303f181c_178x.jpg?v=1655889107");
//   jQuery('#ProductSelect-2010734035032-option-color-Black').click();
// })

// jQuery('#ProductSelect-2011130527832-option-material-Leather').click(function(){
//    $(".ProductSelectImg-2011130527832-option-color-Black").attr("src","https://cdn.shopify.com/s/files/1/0260/5259/1691/products/1_778b55c8-f2ab-413c-a14f-5f4c1dd76fb5_178x.jpg?v=1665410684");
//   jQuery('#ProductSelect-2011130527832-option-color-Black').click();
// })
//     jQuery('#ProductSelect-2011130527832-option-material-Fabric').click(function(){
//        $(".ProductSelectImg-2011130527832-option-color-Black").attr("src","https://cdn.shopify.com/s/files/1/0260/5259/1691/products/1_1d4792ed-e659-437a-ad82-ce35587e8a75_178x.jpg?v=1665492948");
//   jQuery('#ProductSelect-2011130527832-option-color-Black').click();
// })

// jQuery('#ProductSelect-7349658419288-option-material-Leather').click(function(){
 
//         jQuery('#ProductSelect-7349658419288-option-color-Carbon-PVC').removeAttr('disabled');
//   jQuery('#ProductSelect-7349658419288-option-color-Carbon-PVC').click();
//   })
// jQuery('#ProductSelect-7349658419288-option-material-Fabric').click(function(){

//  jQuery('#ProductSelect-7349658419288-option-color-Jet-Black').removeAttr('disabled');
//   jQuery('#ProductSelect-7349658419288-option-color-Jet-Black').click();
// })

//  $('.slider-for-data').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: true,
//   // fade: true,
//   asNavFor: '.slider-nav-btn'

// });
// $('.slider-nav-btn').slick({
//   slidesToShow: 5,
//   slidesToScroll: 1,
//   asNavFor: '.slider-for-data',
//   dots: false,
//   //centerMode: true,
//   infinite: true,
//   focusOnSelect: true,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1
        
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     }
   
//   ]
// });

// $('.slider-for-data-new').slick({
 
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   // fade: true,
//   asNavFor: '.slider-nav-btn-new'

// });
// $('.slider-nav-btn-new').slick({
//   slidesToShow: 5,
//   slidesToScroll: 1,
//    arrows: false,
//   asNavFor: '.slider-for-data-new',
//   dots: false,
//   //centerMode: true,
//   infinite: true,
//   focusOnSelect: true,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1
        
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     }
   
//   ]
// });
// jQuery('#template--22134639984954__main-product-1-0').click(function(){
  
//    // $(".ProductSelectImg-2010734035032-option-color-Black").attr("src","https://cdn.shopify.com/s/files/1/0260/5259/1691/products/BLACK_1G_2992001b-aaf5-42ca-b367-d53aa1384ae1_178x.jpg?v=1645637100");
//   jQuery('#template--22134639984954__main-product-2-0').click();
// })
// jQuery('#template--22134639984954__main-product-1-1').click(function(){
  
//    // $(".ProductSelectImg-2010734035032-option-color-Black").attr("src","https://cdn.shopify.com/s/files/1/0260/5259/1691/products/BLACK_1G_2992001b-aaf5-42ca-b367-d53aa1384ae1_178x.jpg?v=1645637100");
//   jQuery('#template--22134639984954__main-product-2-5').click();
// })
// jQuery('#template--22097715822906__main-product-1-0').click(function(){
  
//    // $(".ProductSelectImg-2010734035032-option-color-Black").attr("src","https://cdn.shopify.com/s/files/1/0260/5259/1691/products/BLACK_1G_2992001b-aaf5-42ca-b367-d53aa1384ae1_178x.jpg?v=1645637100");
//   jQuery('#template--22097715822906__main-product-2-0').click();
// })
// jQuery('#template--22097715822906__main-product-1-1').click(function(){
  
//    // $(".ProductSelectImg-2010734035032-option-color-Black").attr("src","https://cdn.shopify.com/s/files/1/0260/5259/1691/products/BLACK_1G_2992001b-aaf5-42ca-b367-d53aa1384ae1_178x.jpg?v=1645637100");
//   jQuery('#template--22097715822906__main-product-2-0').click();
// })

// jQuery(document).ready(function(){
//   jQuery("#tab1-btn").click(function(){ 
//    jQuery(this).addClass("active-tab");
//    jQuery("#tab2-btn").removeClass("active-tab");
//   jQuery("#tab-box1").show();  jQuery("#tab-box2").hide();

//   });
//   jQuery("#tab2-btn").click(function(){
//     jQuery(this).addClass("active-tab");
//     jQuery("#tab1-btn").removeClass("active-tab");
//     jQuery("#tab-box1").hide();  jQuery("#tab-box2").show();
//   });
 
// });